/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Font_SizeInputs */

const en_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const fr_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const de_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const it_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const ru_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const es_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const zh_cn2_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const ja_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const hi_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

const pt_pt2_options_metrics_font_size = /** @type {(inputs: Options_Metrics_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics Font Size`)
};

/**
* | output |
* | --- |
* | "Metrics Font Size" |
*
* @param {Options_Metrics_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_font_size = /** @type {((inputs?: Options_Metrics_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_font_size(inputs)
	if (locale === "de") return de_options_metrics_font_size(inputs)
	if (locale === "it") return it_options_metrics_font_size(inputs)
	if (locale === "ru") return ru_options_metrics_font_size(inputs)
	if (locale === "es") return es_options_metrics_font_size(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_font_size(inputs)
	if (locale === "ja") return ja_options_metrics_font_size(inputs)
	if (locale === "hi") return hi_options_metrics_font_size(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_font_size(inputs)
	return en_options_metrics_font_size(inputs)
});